import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdminProvider } from './context/AdminContext';

import Home from './pages/Home';
import About from './pages/About';
import ServicePage from './pages/ServicePage';
import Destinations from './pages/Destinations';
import DestinationDetail from './pages/DestinationDetail';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Offices from './pages/Offices';
import TravelAlerts from './pages/TravelAlerts';
import Leadership from './pages/Leadership';
import FeedbackPage from './pages/Feedback';
import AdminFeedback from './pages/admin/AdminFeedback';
import ScrollToTop from './components/ScrollToTop';

import AdminLogin from './pages/admin/AdminLogin';
import { AdminForgotPassword, AdminResetPassword } from './pages/admin/AdminPasswordReset';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminDestinations from './pages/admin/AdminDestinations';
import AdminInquiries from './pages/admin/AdminInquiries';
import AdminBlog from './pages/admin/AdminBlog';
import AdminAlerts from './pages/admin/AdminAlerts';
import AdminUsers from './pages/admin/AdminUsers';
import ProtectedRoute from './pages/admin/ProtectedRoute';

export default function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
      <ScrollToTop />
        <Routes>
          {/* Public site */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/destinations/:slug" element={<DestinationDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/offices" element={<Offices />} />
          <Route path="/travel-alerts" element={<TravelAlerts />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin/reset-password/:token" element={<AdminResetPassword />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/inquiries" element={<ProtectedRoute><AdminInquiries /></ProtectedRoute>} />
          <Route path="/admin/destinations" element={<ProtectedRoute><AdminDestinations /></ProtectedRoute>} />
          <Route path="/admin/blog" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
          <Route path="/admin/alerts" element={<ProtectedRoute><AdminAlerts /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/feedback" element={<ProtectedRoute><AdminFeedback /></ProtectedRoute>} />

          {/* Fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </AdminProvider>
  );
}
